var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "md:grid md:grid-cols-3 md:gap-6" },
    [
      _c("jet-section-title", {
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [_vm._t("title")]
              },
              proxy: true,
            },
            {
              key: "description",
              fn: function () {
                return [_vm._t("description")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mt-5 md:mt-0 md:col-span-2" }, [
        _c(
          "div",
          { staticClass: "px-4 py-5 sm:p-6 bg-white shadow sm:rounded-lg" },
          [_vm._t("content")],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }